/**
 * Beneficiary_Service API client (task 21.2).
 *
 * | Method / Path             | Function                  | Req.  |
 * | ------------------------- | ------------------------- | ----- |
 * | `GET /beneficiaries`      | {@link listBeneficiaries} | R3.1  |
 * | `POST /beneficiaries`     | {@link createBeneficiary} | R3.2  |
 * | `PUT /beneficiaries/{id}` | {@link updateBeneficiary} | R3.3  |
 * | `DELETE /beneficiaries/{id}` | {@link deleteBeneficiary} | R3.4  |
 *
 * Field-validation failures surface as an {@link ApiError} with code
 * `INVALID_BENEFICIARY_FIELD` and a `field` pointing at the offending input
 * (R3.9), which the management view renders inline against that field.
 */

import { apiDelete, apiGet, apiPost, apiPut } from './client.js';
import type { Beneficiary, BeneficiaryInput } from './types.js';

/** List the signed-in customer's beneficiaries (R3.1; empty ok). */
export function listBeneficiaries(): Promise<{ beneficiaries: Beneficiary[] }> {
  return apiGet<{ beneficiaries: Beneficiary[] }>('/beneficiaries');
}

/** Create a beneficiary (R3.2). */
export function createBeneficiary(input: BeneficiaryInput): Promise<Beneficiary> {
  return apiPost<Beneficiary>('/beneficiaries', input);
}

/** Update an owned beneficiary (R3.3). */
export function updateBeneficiary(
  beneficiaryId: string,
  input: BeneficiaryInput,
): Promise<Beneficiary> {
  return apiPut<Beneficiary>(
    `/beneficiaries/${encodeURIComponent(beneficiaryId)}`,
    input,
  );
}

/** Delete an owned beneficiary (R3.4). */
export function deleteBeneficiary(beneficiaryId: string): Promise<void> {
  return apiDelete<void>(`/beneficiaries/${encodeURIComponent(beneficiaryId)}`);
}
